<template>
	<form @submit.prevent="submitForm">
		<div v-if="showError" class="error-msg">
			<p>{{ errorMsg }}</p>
		</div>
		<div v-if="showSucces" class="succes-msg">
			<p>{{ succesMsg }}</p>
		</div>
		<div class="form-row">
			<span class="field-wrapper email">
				<label class="top-level" for="user-forgot-password"
					>Email</label
				>
				<div class="input-wrapper">
					<input
						id="user-forgot-password"
						name="user-forgot-password"
						type="email"
						placeholder="Email"
						v-model="currentUsername"
					/>
				</div>
			</span>
		</div>

		<button class="submit" data-txt="Submit">Submit</button>
	</form>
</template>
<script>
import { defineComponent, ref, computed } from "vue"
import { forgotPassword } from "@streampac.io/chef_sp_1"
import { useAuthenticationData } from "@/composables/useAuthenticationData"
import { useGlobalStore } from "@/stores/global"

export default defineComponent({
	name: "forgotPasswordForm",
	setup(props, { emit }) {
		const globalStore = useGlobalStore()
		const currentUsername = ref("")
		const showError = ref(false)
		const errorMsg = ref("")
		const showSucces = ref(false)
		const succesMsg = ref("")

		const isAuthenticated = computed(() => {
			return useAuthenticationData().data.value.isAuthenticated
		})

		function submitForm() {
			if (currentUsername.value !== "") {
				const postObj =
					"?userName=" + encodeURIComponent(currentUsername.value)

				forgotPassword(isAuthenticated.value, postObj).then(
					(response) => {
						if (response) {
							showSucces.value = true
							showError.value = false
							succesMsg.value = "Email sent"

							//Remove the popup
							setTimeout(() => {
								globalStore.showLoginPopup()
								globalStore.hidePasswordPopup()
							}, 3000)
						} else {
							showError.value = true
							showSucces.value = false
							errorMsg.value = "Something went wrong.."
						}
					}
				)
			}
		}

		return {
			currentUsername,
			showError,
			errorMsg,
			showSucces,
			succesMsg,
			submitForm
		}
	}
})
</script>
